const isString = (str) => typeof str === "string";
export default isString;
